import { useMutation } from "@tanstack/react-query";
import { saveFeedback } from "../../api/feedback";
import { parseError } from "../../utils";

export const useSaveFeedback = () => {
  return useMutation(saveFeedback, {
    onError: (error) => parseError(error),
  });
};
